module.exports = __webpack_public_path__ + "images/avatars/female/14.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/14.svg
// module id = yCid
// module chunks = 118